// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__Yfe8F","offers":"styles_offers__3SsLp","filters":"styles_filters__3ShrA","listPlaceholder":"styles_listPlaceholder__6fQUG"};